import { axiosInstance } from "@nexus/shared-core";
import * as Sentry from "@sentry/react";
import { baseUrl } from "../BaseAPIUrl";

axiosInstance.defaults.baseURL = baseUrl.address;
axiosInstance.defaults.withCredentials = true;

// Custom response interceptor for Sentry tracking
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    Sentry.captureException(error); // Auto-capture all API errors
    return Promise.reject(error);
  }
);

export const api = axiosInstance;
